/** Nothing wordmark — dot-matrix glyph (5×N grid per letter). */
type Props = {
  size?: number
  className?: string
  /** Fit width; height derived from word aspect (~5.8:1). */
  width?: number
  color?: string
}

const LETTERS: Record<string, string[]> = {
  N: ['#...#', '##..#', '#.#.#', '#..##', '#...#'],
  O: ['.###.', '#...#', '#...#', '#...#', '.###.'],
  T: ['#####', '..#..', '..#..', '..#..', '..#..'],
  H: ['#...#', '#...#', '#####', '#...#', '#...#'],
  I: ['#', '#', '#', '#', '#'],
  G: ['.###.', '#....', '#..##', '#...#', '.###.'],
}

const WORD = 'NOTHING'
const LETTER_GAP = 1

function collectDots(): Array<[number, number]> {
  const dots: Array<[number, number]> = []
  let xOff = 0
  for (const ch of WORD) {
    const rows = LETTERS[ch]
    const w = rows[0]?.length ?? 0
    rows.forEach((row, y) => {
      ;[...row].forEach((cell, x) => {
        if (cell === '#') dots.push([xOff + x, y])
      })
    })
    xOff += w + LETTER_GAP
  }
  return dots
}

const DOTS = collectDots()
const VIEW_W = Math.max(...DOTS.map(([x]) => x)) + 1
const VIEW_H = 5

export default function NothingDotLogo({
  size,
  className = '',
  width,
  color = '#111827',
}: Props) {
  const w = width ?? size ?? 64
  const h = Math.round(w * (VIEW_H / VIEW_W))

  return (
    <svg
      className={`nothing-dot-logo ${className}`.trim()}
      viewBox={`0 0 ${VIEW_W} ${VIEW_H}`}
      width={w}
      height={h}
      role="img"
      aria-label="Nothing"
      xmlns="http://www.w3.org/2000/svg"
    >
      {DOTS.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x + 0.5} cy={y + 0.5} r={0.38} fill={color} />
      ))}
    </svg>
  )
}

export const NOTHING_DOT_LOGO_ASPECT = VIEW_W / VIEW_H
